import usePeriodContext from 'app/KinerjaShared/hooks/usePeriodContext'

export function useIsPrior2025() {
  const { periodYear } = usePeriodContext()
  return periodYear < 2025
}
